exports.database_id = "63ad4571f4dfd5491f13b5bf";

exports.endpoint = {
  repository: "https://cloud-3001.lib.cmu.ac.th/knowledge/client",
  pulinetcard: "https://cloud-3001.lib.cmu.ac.th/pulinetcard",
};

exports.server_token = {
  pulinetcard: "Bearer utz7jogGpL3hdtazZPj1apxsdk8FMm",
};
